import React, { Fragment, Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Modal from "react-bootstrap/Modal";
import Select, { components } from "react-select";

// Common Components
import PageTitle from "../../Common/PageTitle";
import Spinner from "../../Common/Spinner";
// Services
import UserService from "../../../services/UserService";
import commonUtiles from "../../../services/CommonUtiles";
import ConfirmationModal from "../../Common/ConfirmationModal";
import AuthService from "../../../services/AuthService";
import userFilters from "../../../services/Constant";
import { ShowFilterCount } from "../../../helper/utility";

export const CustomOption = (props) => {
  const { data } = props;
  return (
    <>
      <components.Option {...props}>
        <input
          type="checkbox"
          className="custom-checkbox ml-0 mb-0 me-2"
          checked={props.isSelected}
          onChange={() => null}
        />
        <label className="mb-0 pl-3">{props.label}</label>
      </components.Option>
      {data.divider && <div style={{ borderTop: "1px dashed #999", marginTop: "-1px" }} />}
    </>
  );
};

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    className="text-gray"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

const userFilterOptions = [
  { value: "username", label: "Email ID", queryParamKey: "username" },
  { value: "firstname", label: "First Name", queryParamKey: "firstname" },
  { value: "lastname", label: "Last Name", queryParamKey: "lastname" },
  { value: "company", label: "Company", queryParamKey: "company", divider: true },
  { value: "active", label: "Active", queryParamKey: "isActive", queryParamValue: true },
  { value: "inactive", label: "Inactive", queryParamKey: "isActive", queryParamValue: true },
  { value: "enabled", label: "Enabled", queryParamKey: "isEnabled", queryParamValue: true },
  { value: "disabled", label: "Disabled", queryParamKey: "isEnabled", queryParamValue: false },
];

// UserList Component
class UserList extends Component {
  constructor() {
    super();
    this.state = {
      users: [],
      loading: false,
      showReset: false,
      searchVal: "",
      filterVal: "",
      pageSize: commonUtiles.getPageSizes[1],
      isPrevBtnActive: "disabled",
      isNextBtnActive: "",
      pageToken: "",
      preTokendata: [],
      nextPageToken: "",
      sort: {
        column: "email",
        direction: "desc",
      },
      showCnfMsg: false,
      statusProp: {},
      changing: false,
      userEmail: "",
      listFilterOptions: [userFilterOptions[0]],
      filterOptions: userFilterOptions,
      selectedTextFilter: "username",
      params: {},
    };
  }

  componentDidMount() {
    const { pageToken, searchVal } = this.state;
    if (this.props?.location?.state?.usertype !== undefined) {
      const valueToSearch = this.props.location.state.usertype;
      const filterIndex = userFilterOptions.findIndex((filter) => filter.value === valueToSearch);
      const filter = userFilterOptions[filterIndex].queryParamKey;
      const filterValue = userFilterOptions[filterIndex].queryParamValue;
      const queryParams = { [filter]: filterValue };
      this.setState({ params: queryParams }); // set to maintain after redirect
      this.getUsers(pageToken, searchVal, "", queryParams);
      this.setState({ selectedTextFilter: userFilters.toString() });
    } else {
      this.getUsers(pageToken, searchVal);
    }
    this.getUserEmail();
  }

  componentWillUnmount() {
    if (this.props?.location?.state?.usertype !== undefined) {
      window.history.replaceState({}, "");
    }
  }

  getUserEmail = () =>
    setTimeout(() => {
      this.setState({ userEmail: AuthService.getUserName() });
    }, 1000);

  // Function uses to filter users' data
  handleSearch = () => {
    const { searchVal, pageToken, selectedTextFilter, params } = this.state;
    const filterVal = searchVal;
    this.setState({ filterVal });
    if (filterVal) {
      this.setState({ isPrevBtnActive: "disabled" });
      this.setState({ preTokendata: [] });
      this.getUsers(pageToken, filterVal, selectedTextFilter, params);
      this.setState({ showReset: true });
    } else {
      this.getUsers(pageToken, "", selectedTextFilter, params);
    }
  };

  // Method use to get Users' data
  getUsers(pageToken, searchVal, selectedFilter, params) {
    const { pageSize, sort } = this.state;
    this.setState({ loading: true });
    UserService.getUsers(pageSize.value, pageToken, searchVal, selectedFilter, params)
      .then((response) => {
        this.setState({ loading: false });
        this.onSort(sort.column, response.data.users, true);
        if (response.data.lastEvaluatedKey) {
          this.setState({ nextPageToken: response.data.lastEvaluatedKey.username });
          this.setState({ isNextBtnActive: "" });
        } else {
          this.setState({ isNextBtnActive: "disabled" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  // Enter key handler
  onKeyDownHandler = (e) => {
    if (e.keyCode === 13) {
      this.handleSearch();
    }
  };

  // Function uses for clear filter data
  onResetHandler = (e) => {
    e.preventDefault();
    this.onReset();
  };

  // Function uses for clear filter data
  onReset = () => {
    const { filterVal } = this.state;
    this.setState({ searchVal: "" });
    this.setState({ preTokendata: [] });
    this.setState({ pageToken: "" });
    this.setState({ showReset: false });

    if (filterVal) {
      this.setState({ isPrevBtnActive: "disabled" });
      this.getUsers("", "");
    }
    this.setState({ filterVal: "" });
  };

  // Function use for sorting table data in ascending and descending order.
  onSort = (column, data, listing) => {
    const { sort } = this.state;
    const direction = !listing ? (sort.direction === "asc" ? "desc" : "asc") : sort.direction;
    const allEqual = data.every((item) => data[0][column] === item[column]);
    let sortedData;
    if (allEqual) {
      sortedData = data.reverse();
    } else {
      sortedData = data.sort((a, b) => commonUtiles.compareValues(a, b, column, direction));
      if (direction === "desc") {
        sortedData.reverse();
      }
    }
    this.setState({
      users: sortedData,
      sort: {
        column,
        direction,
      },
    });
  };

  // Set Arrow direction as per sorting order
  setArrow = (column) => {
    const { sort } = this.state;
    return commonUtiles.setArrow(sort, column);
  };

  // function invoke on Next button click
  btnNextClick = (e) => {
    e.preventDefault();
    const { preTokendata, nextPageToken, filterVal, selectedTextFilter, params } = this.state;
    preTokendata.push(nextPageToken);
    this.setState({ isPrevBtnActive: "" });
    this.getUsers(nextPageToken, filterVal, selectedTextFilter, params);
  };

  // function invoke when Previous button click
  btnPrevClick = (e) => {
    e.preventDefault();
    const { preTokendata, filterVal, selectedTextFilter, params } = this.state;
    if (preTokendata.length > 1) {
      this.getUsers(preTokendata[preTokendata.length - 2], filterVal);
      preTokendata.pop();
    } else {
      preTokendata.pop();
      this.getUsers("", filterVal, selectedTextFilter, params);
      this.setState({ isPrevBtnActive: "disabled" });
    }
    this.setState({ isNextBtnActive: "" });
  };

  // function use to set filter value
  updateInputValue = (evt) => {
    const { filterVal } = this.state;
    this.setState({ searchVal: evt.target.value });
    if (evt.target.value) {
      this.setState({ showReset: true });
    } else {
      this.setState({ showReset: false });
      if (filterVal) {
        this.onReset();
      }
    }
  };

  openConfirmationModal = (statusProp) => {
    this.setState({ showCnfMsg: true, statusProp });
  };

  closeConfirmationModal = (data) => {
    const { statusProp } = this.state;
    if (data) {
      this.updateUserStatus(statusProp.email, !statusProp.userEnable);
    } else {
      this.setState({ statusProp: {}, showCnfMsg: false });
    }
  };

  // function use for update user status (enable/disable)
  updateUserStatus = (email, status) => {
    this.setState({ changing: true });
    UserService.statusUserservice(email, status)
      .then(() => {
        commonUtiles.displayNotification(`User is ${status ? "enabled" : "disabled"} successfully`, "success");
        this.setState({ searchVal: "" });
        this.getUsers("", "");
        this.setState({ statusProp: {}, showCnfMsg: false, changing: false });
      })
      .catch((error) => {
        commonUtiles.displayErrorMessage(error);
        this.setState({ statusProp: {}, showCnfMsg: false, changing: false });
      });
  };

  getModel = () => {
    const { showCnfMsg, changing, statusProp } = this.state;
    return (
      <Modal
        className="confirmModal"
        backdrop="static"
        tabindex="-1"
        show={showCnfMsg}
        onHide={this.closeConfirmationModal}
        centered
      >
        <ConfirmationModal
          closeConfirmationModal={this.closeConfirmationModal}
          message={`Are you sure, you want to ${statusProp.userEnable ? "Disable" : "Enable"} the user?`}
          changing={changing}
        />
      </Modal>
    );
  };

  // handle onChange event of the dropdown
  pageChange = (e) => {
    this.setState({ pageSize: e, preTokendata: [], pageToken: "", isPrevBtnActive: "disabled" }, () => {
      this.handleSearch();
    });
  };

  getSelectedFilters = (filterValues) => {
    const textFilter = userFilters.filter((textGroup) => filterValues.some((selected) => textGroup === selected.value));
    const isActive = filterValues.some((selected) => selected.value === "active");
    const inActive = filterValues.some((selected) => selected.value === "inactive");
    const enabled = filterValues.some((selected) => selected.value === "enabled");
    const disabled = filterValues.some((selected) => selected.value === "disabled");
    const queryParams = {};
    console.log(isActive, inActive, enabled, disabled);
    if (isActive && !inActive && !enabled && !disabled) {
      queryParams.isActive = true;
    } else if (!isActive && inActive && !enabled && !disabled) {
      queryParams.isActive = false;
    } else if (!isActive && inActive && enabled && disabled) {
      queryParams.isActive = false;
    } else if (!isActive && !inActive && enabled && !disabled) {
      queryParams.isEnabled = true;
    } else if (!isActive && inActive && enabled && !disabled) {
      queryParams.isEnabled = true;
      queryParams.isActive = false;
    } else if (!isActive && !inActive && !enabled && disabled) {
      queryParams.isEnabled = false;
    } else if (!isActive && inActive && !enabled && disabled) {
      queryParams.isActive = false;
      queryParams.isEnabled = false;
    } else if (isActive && !inActive && enabled && !disabled) {
      queryParams.isActive = true;
      queryParams.isEnabled = true;
    } else if (isActive && inActive && enabled && !disabled) {
      queryParams.isEnabled = true;
    } else if (isActive && inActive && !enabled && disabled) {
      queryParams.isEnabled = false;
    } else if (isActive && !inActive && !enabled && !disabled) {
      queryParams.isActive = true;
    } else if (isActive && !inActive && enabled && disabled) {
      queryParams.isActive = true;
    } else if (isActive && !inActive && !enabled && disabled) {
      queryParams.isActive = true;
      queryParams.isEnabled = false;
    }
    this.setState({ listFilterOptions: filterValues, selectedTextFilter: textFilter, params: queryParams });
  };

  render() {
    const {
      users,
      pageSize,
      isPrevBtnActive,
      isNextBtnActive,
      loading,
      showReset,
      searchVal,
      showCnfMsg,
      userEmail,
      filterOptions,
    } = this.state;

    // limit userlist to 10 records.
    const userList = users.slice(0, pageSize.value);
    return (
      <>
        {showCnfMsg ? this.getModel() : null}
        <PageTitle title="Users" class="" />
        <div className="card">
          <div className="card-header bg-gray-dark">
            <div className="row flex-grow-1 d-flex flex-wrap align-items-center w-100">
              <div className="col-md me-auto d-flex flex-wrap-sm pe-3">
                <div className="input-group flex-nowrap w-auto me-2">
                  <div className="input-icon">
                    <input
                      type="text"
                      className="form-control user-input search-input"
                      onKeyDown={this.onKeyDownHandler}
                      value={searchVal}
                      onChange={this.updateInputValue}
                      placeholder="Search"
                      autoComplete="off"
                    />
                    {showReset ? (
                      <a
                        href="#"
                        aria-label="link"
                        onClick={this.onResetHandler}
                        className="input-icon-addon custom-i-addon"
                      >
                        <i className="bi bi-x-lg" />
                      </a>
                    ) : null}
                  </div>
                  <button className="btn btn-primary" aria-label="button" type="button" onClick={this.handleSearch}>
                    <i className="fa fa-search" />
                  </button>
                </div>
                <Select
                  isMulti
                  options={filterOptions}
                  defaultValue={[
                    this.props.location.state && this.props.location.state.usertype
                      ? filterOptions[
                          userFilterOptions.findIndex((filter) => filter.value === this.props.location.state.usertype)
                        ]
                      : filterOptions[0],
                  ]}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  className="select-sdd w-320 custom-sel"
                  classNamePrefix="react-select"
                  autoFocus={false}
                  isSearchable={false}
                  placeholder="Search by Filter"
                  components={{ Option: CustomOption, MultiValue: ShowFilterCount }}
                  onChange={(e) => this.getSelectedFilters(e)}
                />
              </div>
              <div className="col-auto ms-auto text-end align-items-center flex-shrink-0">
                <Link to="/users/createuser" class="btn my-1 flex-shrink-0 btn-primary">
                  Create User
                </Link>
              </div>
            </div>
          </div>
          <div className="table-min-height">
            <table className="table table-outline table-vcenter card-table">
              <thead className="text-nowrap table-head">
                <tr>
                  <th onClick={() => this.onSort("email", users)} className="curser-pointer cell-w-200 header-sticky">
                    Email Address
                    <span className={this.setArrow("email")} />
                  </th>
                  <th onClick={() => this.onSort("name", users)} className="curser-pointer cell-w-130 header-sticky">
                    First Name
                    <span className={this.setArrow("name")} />
                  </th>
                  <th
                    onClick={() => this.onSort("lastName", users)}
                    className="curser-pointer cell-w-130 header-sticky"
                  >
                    Last Name
                    <span className={this.setArrow("lastName")} />
                  </th>
                  <th onClick={() => this.onSort("company", users)} className="curser-pointer cell-w-120 header-sticky">
                    Company
                    <span className={this.setArrow("company")} />
                  </th>
                  <th onClick={() => this.onSort("role", users)} className="curser-pointer cell-w-80 header-sticky">
                    Role
                    <span className={this.setArrow("role")} />
                  </th>
                  <th
                    onClick={() => this.onSort("isActive", users)}
                    className="curser-pointer cell-w-120 header-sticky"
                  >
                    isActive
                    <span className={this.setArrow("isActive")} />
                  </th>
                  <th
                    onClick={() => this.onSort("lastLoginTime", users)}
                    className="curser-pointer cell-w-170 header-sticky"
                  >
                    Last Login Time
                    <span className={this.setArrow("lastLoginTime")} />
                  </th>
                  <th
                    onClick={() => this.onSort("userEnable", users)}
                    className="text-center curser-pointer cell-w-100 header-sticky"
                  >
                    Status
                    <span className={this.setArrow("userEnable")} />
                  </th>
                  <th className="text-center cell-w-100 header-sticky">Action</th>
                </tr>
              </thead>
              {loading ? (
                <tbody>
                  <tr>
                    <td colSpan="8" aria-label="td" className="p-7">
                      <Spinner />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {userList?.length ? (
                    userList?.map((user) => (
                      <tr key={user.userId}>
                        <td>
                          <div className="cell-mx-width" data-tip={user.email}>
                            {user.email}
                          </div>
                          <ReactTooltip place="bottom" multiline type="light" effect="solid" />
                        </td>
                        <td>
                          <div className="cell-mx-width" data-tip={user.name}>
                            {user.name}
                          </div>
                        </td>
                        <td>
                          <div className="cell-mx-width" data-tip={user.lastName}>
                            {user.lastName}
                          </div>
                        </td>
                        <td>
                          <div className="cell-mx-width" data-tip={user.company}>
                            {user.company}
                          </div>
                        </td>
                        <td>
                          <div className="capitilize-column cell-mx-width">{user.role}</div>
                        </td>
                        <td>
                          <div className="capitilize-column">
                            {user.isActive ? (
                              <span className="badge badge-success">Active</span>
                            ) : (
                              <span className="badge badge-danger">Inactive</span>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="capitilize-column cell-mx-width">
                            {user?.lastLoginTime ? commonUtiles.formatDate(user?.lastLoginTime) : ""}
                          </div>
                        </td>
                        <td className="text-center">
                          {user.userEnable ? (
                            <span className="badge badge-success">Enabled</span>
                          ) : (
                            <span className="badge badge-danger">Disable</span>
                          )}
                        </td>
                        <td className="text-center">
                          <Dropdown className="ms-auto" container="body">
                            <Dropdown.Toggle
                              as={CustomToggle}
                              id="dropdown-custom-components"
                              class="nav-link pe-0 leading-none"
                              align="end"
                            >
                              <i className="fa fa-ellipsis-h xx-large-icon" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu-right user-list-dropdown">
                              <Link
                                to={`/users/edit/${encodeURIComponent(user.email)}`}
                                class="btn-link-dropdown dropdown-item"
                              >
                                Edit
                              </Link>
                              {userEmail !== user.email ? <Dropdown.Divider /> : null}
                              {userEmail !== user.email ? (
                                <Link
                                  to="/users"
                                  href="#"
                                  onClick={() => this.openConfirmationModal(user)}
                                  class="btn-link-dropdown dropdown-item"
                                >
                                  {user.userEnable ? "Disable" : "Enable"}
                                </Link>
                              ) : null}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">
                        <div className="text-center py-5">
                          <div className="mb-5">
                            <i className="fa fa-2x fa-user text-primary" />
                          </div>
                          <h3 className="text-muted mb-3">No Data Found</h3>
                          <p className="h6 text-muted font-weight-light">Please try with different keyword</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>

          {users.length ? (
            <div className="card-footer">
              <nav aria-label="Page navigation example" className="d-flex justify-content-end">
                <Select
                  onChange={this.pageChange}
                  options={commonUtiles.getPageSizes}
                  name="role"
                  className="select-sdd me-3 w-70"
                  autoFocus={false}
                  isSearchable={false}
                  menuPlacement="top"
                  value={pageSize}
                  styles={commonUtiles.getDropDownStyleForPage()}
                />
                <ul className="pagination justify-content-end mb-0">
                  {isPrevBtnActive === "disabled" ? (
                    <li className="page-item disabled">
                      <span className="page-link">Previous</span>
                    </li>
                  ) : (
                    <li className="page-item">
                      <a href="#" className="page-link" onClick={this.btnPrevClick}>
                        Previous
                      </a>
                    </li>
                  )}
                  {isNextBtnActive === "disabled" ? (
                    <li className="page-item disabled">
                      <span className="page-link">Next</span>
                    </li>
                  ) : (
                    <li className="page-item">
                      <a href="#" className="page-link" onClick={this.btnNextClick}>
                        Next
                      </a>
                    </li>
                  )}
                </ul>
              </nav>
            </div>
          ) : null}
        </div>
      </>
    );
  }
}
export default UserList;
